import { enableProdMode } from '@angular/core';
import { environment } from '@mogenius/environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import browserUpdate from 'browser-update';

browserUpdate({
  required: { e: -2, f: -2, o: -2, s: -2, c: -2 },
  insecure: true,
  unsupported: true,
  notify_esr: false,
  text: '<i class="pi pi-info-circle" style="font-size:18px;vertical-align:middle;margin-right:6px"></i>Your web browser ({brow_name}) is outdated.<br><a{up_but}>Update your browser</a><br><span style="font-size:12px;opacity:0.6">Keep your browser up to date for the best mogenius experience.</span>',
  style: 'top',
  no_permanent_hide: false
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
